module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABGdBTUEAALGPC/xhBQAAAKVJREFUOBGd0jEOglAMxvFq4BKYyODIKdw5BokMHsdruHgWBxcO4ua/JiUQn7X1JV8eoa8/SEFEZEMq8s+qrWng4kqy0J6eB2nJu1mRDKTAREYyL32LKFQETIpALhCBQoAHpYASdODmxxDt4K9dZ3QjT3L2Dm+dYkOtI3dyJNn/SJYziHw1nrFeS8AqKagEpCAPCEERwIUywFeop3KyamLXYV/I7gWSYChTSbVokwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/x.png
// module id = 273
// module chunks = 0